"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyerFxQuoteSchema = void 0;
const zod_1 = require("zod");
const positiveDecimal = zod_1.z.string().regex(/^\d+(\.\d+)?$/).refine(value => /[1-9]/.test(value));
exports.BuyerFxQuoteSchema = zod_1.z.object({
    version: zod_1.z.literal(1),
    quoteId: zod_1.z.string().regex(/^fxq_/),
    acquirerAccountId: zod_1.z.string().min(1),
    merchantAccountRef: zod_1.z.string().regex(/^acct_/),
    chargeCurrency: zod_1.z.string().regex(/^[A-Z]{3}$/),
    settlementCurrency: zod_1.z.literal('BRL'),
    exchangeRate: positiveDecimal,
    baseRate: positiveDecimal,
    markupPercentage: zod_1.z.string().regex(/^\d+(\.\d+)?$/),
    expiresAt: zod_1.z.string().datetime(),
}).strict();
//# sourceMappingURL=buyer-fx.js.map